/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceDTO,
    LearningCompetenceDTOFromJSON,
    LearningCompetenceDTOFromJSONTyped,
    LearningCompetenceDTOToJSON,
} from './LearningCompetenceDTO';

/**
 * 
 * @export
 * @interface LearningCompetenceDTOPagedResponse
 */
export interface LearningCompetenceDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof LearningCompetenceDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof LearningCompetenceDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof LearningCompetenceDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof LearningCompetenceDTOPagedResponse
     */
    data?: Array<LearningCompetenceDTO> | null;
}

export function LearningCompetenceDTOPagedResponseFromJSON(json: any): LearningCompetenceDTOPagedResponse {
    return LearningCompetenceDTOPagedResponseFromJSONTyped(json, false);
}

export function LearningCompetenceDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningCompetenceDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
    };
}

export function LearningCompetenceDTOPagedResponseToJSON(value?: LearningCompetenceDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(LearningCompetenceDTOToJSON)),
    };
}

